import { RadioButtons } from "@egovernments/digit-ui-react-components";
import { Box, Grid } from "@mui/material";
import React from "react";

const ActionButtons = ({ actions, currentAction, onSelect }) => {
  return (
    <Grid container alignItems="center" spacing={2} sx={{ marginTop: "10px" }}>
      <Grid item sx={{ marginBottom: "25px" }}>
        <b>Actions:</b>
      </Grid>
      <Grid item xs>
        <RadioButtons
          isMandatory={false}
          options={actions}
          selectedOption={currentAction}
          optionsKey="action"
          onSelect={onSelect}
          style={{ display: "flex", gap: "3rem", margin: 0 }}
        />
      </Grid>
    </Grid>
  );
};

export default ActionButtons;
